<script>
import Button from "@core/components/common/Button.vue";
export default {
    components: {Button},
    props: {
        attachments: {
            default() {
                return [];
            }
        }
    },
}
</script>

<template>
    <div v-if="attachments && attachments.length > 0" class="float-right">
        <div class="d-flex align-items-center justify-content-end mb-1">
            <feather-icon
                icon="PaperclipIcon"
            />
            <h5 class="font-weight-bolder text-body mb-0 ml-50">
                {{ attachments.length }} Attachment{{ attachments.length > 1 ? 's' : '' }}
            </h5>
        </div>
        <div class="d-flex flex-column">
            <span
                v-for="attachment in attachments"
                class="text-muted font-weight-bolder align-text-top"
            >
                {{ attachment.name }}
                <Button size="sm" class="ml-50" @click="$emit('download', attachment)">
                    <feather-icon
                        icon="DownloadCloudIcon"
                    />
                </Button>
                <Button
                    v-if="attachment.mimeType === 'application/pdf'"
                    size="sm"
                    class="ml-50"
                    @click="$emit('view', attachment)"
                >
                    <feather-icon
                        icon="EyeIcon"
                    />
                </Button>
            </span>
        </div>
    </div>
</template>
